import type { SVGProps } from "react";
const SvgLbbwLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-3 -3 486 106" {...props}>
    <path
      style={{
        fill: "#000",
        fillOpacity: 0,
      }}
      fill="none"
      d="M0 0h480v100H0z"
    />
    <path
      d="M17.18 83.644V.002H.001v99.896h59.357V83.644zm339.988-12.522c0-13.451-5.862-21.039-16.117-24.105v-.268c7.592-3.192 12.787-9.986 12.787-21.576 0-16.382-9.725-25.171-29.169-25.171h-34.768v99.896h35.432c22.643 0 31.835-10.795 31.835-28.776m-17.187-1.194c0 11.452-4.923 14.916-14.249 14.916H306.42V55.411h18.645c10.523 0 14.916 4.128 14.916 14.517m-2.663-41.556c0 9.192-3.863 13.32-12.786 13.32H306.55V15.321h17.583c9.192 0 13.185 3.192 13.185 13.051M412.641.002l-13.25 66.452-1.861 11.187h-.399l-1.734-11.325L382.212.002h-18.049l21.311 99.896h21.58l12.787-65.508 1.864-12.13h.399l1.731 12.13 12.917 65.508h21.043L479.11.002h-17.381l-13.327 65.911-1.861 11.329h-.399l-1.734-11.187L431.159.002zm-272.929 71.12c0-13.451-5.862-21.039-16.117-24.105v-.268c7.592-3.192 12.787-9.986 12.787-21.576 0-16.382-9.725-25.171-29.168-25.171H72.448v99.896h35.43c22.646 0 31.834-10.795 31.834-28.776m-17.183-1.194c0 11.452-4.93 14.916-14.252 14.916H88.964V55.411h18.645c10.523 0 14.92 4.128 14.92 14.517m-2.663-41.556c0 9.192-3.863 13.32-12.787 13.32H89.095V15.321h17.585c9.189 0 13.186 3.192 13.186 13.051M262.141.002h-99.864v19.92h99.864zm0 39.953h-99.864v19.916h99.864zm0 59.943h-99.864V79.975h99.864z"
      style={{
        fill: "#123250",
      }}
    />
  </svg>
);
export default SvgLbbwLogo;
